module.exports = __webpack_public_path__ + "img/certificate2-04.db36a767.png";